import { useState, useEffect } from "react";

const navLinks = [
  { label: "HOME", href: "#home" },
  { label: "ABOUT", href: "#about" },
  { label: "SERVICES", href: "#services" },
  { label: "PORTFOLIO", href: "#portfolio" },
  { label: "CONTACT", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("HOME");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (href: string, label: string) => {
    setActive(label);
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0a0a0a]/95 border-b border-white/10 backdrop-blur-md" : "bg-transparent"
      }`}
      style={{ height: "80px" }}
    >
      <div className="w-full h-full flex items-center justify-between px-5 sm:px-8 md:px-16">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNav("#home", "HOME"); }}
          className="flex items-center cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/b9776ec7c1da350797bd71cdecd03ae9/ad8efe877ad37fb904eb80ba5955f67a.jpeg"
            alt="Logo"
            className="h-9 sm:h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href, link.label); }}
              className={`text-xs tracking-[3px] font-light transition-colors duration-300 cursor-pointer whitespace-nowrap relative group ${
                active === link.label ? "text-[#c9a84c]" : "text-white/70 hover:text-[#c9a84c]"
              }`}
            >
              {link.label}
              <span className={`absolute -bottom-1 left-0 h-px bg-[#c9a84c] transition-all duration-300 ${active === link.label ? "w-full" : "w-0 group-hover:w-full"}`} />
            </a>
          ))}
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer p-2 -mr-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-px bg-white transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-6 h-px bg-white transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-px bg-white transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 w-full bg-[#0a0a0a]/98 border-b border-white/10 transition-all duration-300 overflow-hidden ${
          menuOpen ? "max-h-96 py-6" : "max-h-0"
        }`}
      >
        {navLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            onClick={(e) => { e.preventDefault(); handleNav(link.href, link.label); }}
            className="block px-8 py-3 text-xs tracking-[3px] text-white/70 hover:text-[#c9a84c] transition-colors cursor-pointer"
          >
            {link.label}
          </a>
        ))}
      </div>
    </nav>
  );
}
